import characters from './characters/index.jsx';
import effects from './effects/index.jsx';
import furniture from './furniture/index.jsx';
import monsters from './monsters/index.jsx';
import npc from './npc/index.jsx';
import objects from './objects/index.jsx';

export default {
    characters,
    effects,
    furniture,
    monsters,
    npc,
    objects
}